import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'
export const categoryAdd = createAsyncThunk(
    'category/categoryAdd',
    async ({ name, image, subcategories = [], commission = 0 }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const formData = new FormData()
            formData.append('name', name)
            formData.append('image', image)
            formData.append('subcategories', JSON.stringify(subcategories))
            formData.append('commission', commission)
            const { data } = await api.post('/category-add', formData, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_category = createAsyncThunk(
    'category/get_category',
    async ({ parPage, page, searchValue }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/category-get?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const update_category = createAsyncThunk(
    'category/update_category',
    async ({ categoryId, name, image, subcategories = [], commission = 0 }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const formData = new FormData()
            formData.append('name', name)
            if (image) {
                formData.append('image', image)
            }
            formData.append('subcategories', JSON.stringify(subcategories))
            formData.append('commission', commission)
            const { data } = await api.put(`/category-update/${categoryId}`, formData, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const delete_category = createAsyncThunk(
    'category/delete_category',
    async (categoryId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.delete(`/category-delete/${categoryId}`, { withCredentials: true })
            return fulfillWithValue({ ...data, categoryId })
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)



export const categoryReducer = createSlice({
    name: 'category',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        categorys: [],
        totalCategory : 0
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers: {
        [categoryAdd.pending]: (state, _) => {
            state.loader = true
        },
        [categoryAdd.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        },
        [categoryAdd.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
            state.categorys = [...state.categorys, payload.category]
        },
        [get_category.fulfilled]: (state, { payload }) => {
            state.totalCategory = payload.totalCategory
            state.categorys = payload.categorys
        },
        [update_category.pending]: (state, _) => {
            state.loader = true
        },
        [update_category.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        },
        [update_category.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
            const index = state.categorys.findIndex(c => c._id === payload.category._id)
            if (index !== -1) {
                state.categorys[index] = payload.category
            }
        },
        [delete_category.pending]: (state, _) => {
            state.loader = true
        },
        [delete_category.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        },
        [delete_category.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
            state.categorys = state.categorys.filter(c => c._id !== payload.categoryId)
        },
    }

})
export const { messageClear } = categoryReducer.actions
export default categoryReducer.reducer